import {Box, Heading, Grid, GridItem, Button} from "@chakra-ui/react";
import { CheckboxContainer, CheckboxControl } from "formik-chakra-ui";
import React, { useEffect, useState } from "react";
import InputBox from "../../../../components/InputBox";
import MultiSelectInputBox from "../../../../components/MultiSelectInputBox";
import {
    CampaignInventoryRestriction,
    TargettingOptionDevices,
} from "../../../../constant";
import {TEXT_COLOR} from "../../../../layout/constant/MenuList";
import {Flex} from "@chakra-ui/layout";

const MediaStrategiesStep = ({ values, setFieldValue, errors, activeStep, steps, prevStep, nextStep  }) => {
    const [selectedInventory, setSelectedInventory] = useState([]);

    useEffect(() => {
        if (values?.detail?.inventoryRestrictions?.length) {
            setSelectedInventory(
                values.detail.inventoryRestrictions.map((el) => {
                    const id = CampaignInventoryRestriction.filter((e) => e.value === el);
                    return { value: el, label: id?.[0]?.label };
                })
            );
        }
    }, [values?.detail?.inventoryRestrictions]);

    return (
        <Box p={4}>
            <Box mb={6} display="flex" justifyContent="space-between">
                <Heading fontSize="xl" color={"#757998"}>
                    Media Strategies
                </Heading>
                <Heading fontSize="md" color="#A7A9BD">
                    3 steps to complete
                </Heading>
            </Box>

            <Grid className="flex-for-mobile" templateColumns="repeat(12, 1fr)" gap={"8px"}>
                <GridItem colSpan={12}>
                    <CheckboxContainer
                        name="detail.devices"
                        label="Devices"
                        labelProps={{
                            color: "gray",
                            fontSize: "sm",
                        }}
                        stackProps={{
                            direction: "row",
                            gap: 3,
                            padding: 0,
                        }}
                    >
                        {TargettingOptionDevices.map((family, index) => (
                            <CheckboxControl
                                key={index}
                                colorScheme="blue"
                                name="detail.devices"
                                value={family.value}
                            >
                                {family.label}
                            </CheckboxControl>
                        ))}
                    </CheckboxContainer>
                </GridItem>
                <GridItem colSpan={12}>
                    <InputBox name="detail.language" placeholder="Language, Split?" />
                </GridItem>
                <GridItem colSpan={6}>
                    <InputBox
                        name="detail.tactics"
                        placeholder="Tactics (Retargeting, Lookalike, Lists)"
                    />
                </GridItem>
                <GridItem colSpan={6}>
                    <InputBox
                        name="detail.dayPartingRequirements"
                        placeholder="Day Parting Requirements"
                    />
                </GridItem>
                <GridItem colSpan={6}>
                    <InputBox
                        name="detail.optimizationExclusions"
                        placeholder="Optimization Exclusions?"
                    />
                </GridItem>
                <GridItem colSpan={12}>
                    <InputBox
                        name="detail.frequencyCapping"
                        placeholder="Frequency Capping (We recommend 1x/24 hours or 2x/24 hours for Retargeting)"
                    />
                </GridItem>
                <GridItem colSpan={6}>
                    <MultiSelectInputBox
                        label="Inventory Restrictions/Digital Content Labels"
                        name="detail.inventoryRestrictions"
                        options={CampaignInventoryRestriction}
                        value={selectedInventory}
                        placeholder={`Select Restrictions`}
                        onChange={(e) => {
                            setSelectedInventory(e.map((v) => v))
                            setFieldValue(
                                "detail.inventoryRestrictions",
                                e.map((v) => v["value"])
                            )
                        }}
                    />
                </GridItem>
                <GridItem></GridItem>
                <GridItem colSpan={6}>
                    <InputBox name="detail.whitelist" placeholder="Placement" />
                </GridItem>
                <GridItem colSpan={6}>
                    <InputBox
                        name="detail.blacklist"
                        placeholder="Placement Exclusions"
                    />
                </GridItem>
                {/*<GridItem colSpan={12}>*/}
                {/*    <InputBox*/}
                {/*        name="detail.campaignBasic.notes"*/}
                {/*        type="url"*/}
                {/*        placeholder={"Notes"}*/}
                {/*    />*/}
                {/*</GridItem>*/}
            </Grid>
            <Flex width="100%" justify="flex-end" py={10}>
                <Button
                    mr={4}
                    onClick={prevStep}
                    colorScheme='blue' variant='outline' borderRadius={0} px={10}
                >
                    Back
                </Button>

                <Button mr={4} onClick={nextStep} colorScheme='green' variant='solid' borderRadius={0} px={10}>
                    Next
                </Button>

            </Flex>
        </Box>
    );
};

export default MediaStrategiesStep;
